import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, Subscription } from 'rxjs';

//Services
import { AuthService } from '../../services/auth/auth.service';

@Injectable()
export class AuthGuard  {

    constructor(private router: Router, private authService: AuthService) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot):  Observable<boolean> | Promise<boolean> | boolean {
        if (this.authService.isAuthenticated()) {
            return true;
        }

        //this.router.navigate(['/login'], { queryParams: { return: state.url } });
        this.router.navigate(['/login']);
        return false;
    }
}